import { render, staticRenderFns } from "./IndexAvatar.vue?vue&type=template&id=c05d5ac0"
import script from "./IndexAvatar.vue?vue&type=script&lang=ts"
export * from "./IndexAvatar.vue?vue&type=script&lang=ts"
import style0 from "./IndexAvatar.vue?vue&type=style&index=0&id=c05d5ac0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports